export const LEARN_MORE_METRIC_NAME = 'program_learn_more.click'
export const REQUEST_SCHOOL_METRIC_NAME = 'program_request_school.submit'
